import { QuestionAnswerReviewComment } from "@prisma/client";
import { Translate } from "next-translate";
import * as zod from "zod";
import { QuestionAnswer } from "~/models/questionAnswer";

/* --- INTERFACE --- */
export interface QaReviewCommentCountIDictionary {
  [index: QuestionAnswer["id"]]: number;
}
export type QaReviewComment = QuestionAnswerReviewComment;
export type QaReviewCommentMode = "forNormalUser" | "forAdminUser";

/* --- CONSTANTS --- */
export const QA_REVIEW_COMMENT_SCHEMA = zod.object({
  content: zod.string().nonempty(),
  targetText: zod.string(),
});

/* --- FUNCTION --- */
export function getTargetQaFieldText(
  field: QaReviewComment["targetQaField"],
  t: Translate
): string {
  switch (field) {
    case "answerContent":
      return t("question:review-comment.answer-content");
    case "answerSummaryContent":
      return t("question:review-comment.answer-summary-content");
    case "coverImage":
      return "キービジュアル";
    case "overview":
      return t("question:review-comment.overview");
    case "questionContent":
      return t("question:review-comment.question-content");
    case "subtopic":
      return "サブトピック";
  }
}

const TARGET_QA_FIELDS: QaReviewComment["targetQaField"][] = [
  "answerContent",
  "answerSummaryContent",
  "coverImage",
  "overview",
  "questionContent",
  "subtopic",
];

export function isValidTargetQaField(
  field: any
): field is QaReviewComment["targetQaField"] {
  return TARGET_QA_FIELDS.includes(field);
}
